<template>
  <div>
    <app-header>
      <template #title>
        <img v-if="client.logo" :src="client.logo" alt="" class="client-logo me-3">
        <h1 class="d-inline">{{ client.display_name ? client.display_name : client.company }}</h1>
      </template>
    </app-header>

    <ul id="horizontal-nav" class="nav nav-horizontal">
      <router-link tag="li" class="nav-item" :to="{ name: 'clients.timeline' }">
        <a class="nav-link">Timeline</a>
      </router-link>
      <router-link tag="li" class="nav-item" :to="{ name: 'clients.details' }">
        <a class="nav-link">Client Details</a>
      </router-link>
      <router-link tag="li" class="nav-item" :to="{ name: 'clients.contacts' }">
        <a class="nav-link">Contacts</a>
      </router-link>
    </ul>

    <router-view v-if="loaded"></router-view>
  </div>
</template>

<script>
import { helperComputed, helperMethods } from 'vx/modules/clients'

export default {
  data () {
    return {
      loaded: false
    }
  },

  computed: {
    ...helperComputed
  },

  watch: {
    '$route.params.client_id' () {
      this.loaded = false
      this.loadData()
    }
  },

  created () {
    this.loadData()
  },

  methods: {
    ...helperMethods,

    async loadData () {
      await this.getClient(this.$route.params.client_id)
      this.loaded = true
    }
  }
}
</script>

<style scoped>
.client-logo {
  max-height: 2.5rem;
  vertical-align: middle;
}
</style>
